import cx from 'classnames'
import isEqual from 'lodash/isEqual'
import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { ReactComponent as RightChevronIcon } from 'assets/icons/chevron-right--small__16.svg'
import { BreadcrumbsContextType, RootState } from 'types'

import { AlmanacFileBreadcrumbsContainer as AlmanacFileBreadcrumbs } from './AlmanacFileBreadcrumbs'
import Styles from './Breadcrumbs.module.scss'
import { GroupBreadcrumbs } from './GroupBreadcrumbs'

interface Props {
  className?: string
}

export interface BreadcrumbSegmentProps {
  title: string
  icon?: ReactNode
  to: string
}

export const Breadcrumbs = ({ className }: Props) => {
  const breadcrumbsContext = useSelector(({ breadcrumbsContext }: RootState) => breadcrumbsContext, isEqual)

  if (!breadcrumbsContext) return null

  if (breadcrumbsContext.type === BreadcrumbsContextType.AlmanacFile) {
    if (breadcrumbsContext.assetType === 'Article') return <AlmanacFileBreadcrumbs {...breadcrumbsContext} />
    return null
  }

  if (breadcrumbsContext.type === BreadcrumbsContextType.Page) {
    return <>{breadcrumbsContext.page.title}</>
  }

  if (breadcrumbsContext.type === BreadcrumbsContextType.Group) {
    const { workspaceId, group, onEmojiUpdate } = breadcrumbsContext

    return <GroupBreadcrumbs workspaceId={workspaceId} group={group} onEmojiUpdate={onEmojiUpdate} />
  }

  return (
    <ul className={cx(Styles.breadcrumbs, className)}>
      {breadcrumbsContext.links.map(({ key, title, to }, index) => (
        <li className={Styles.breadcrumb} key={key}>
          <Link className={Styles.link} to={to}>
            {title}
          </Link>
          {index < breadcrumbsContext.links.length - 1 && <RightChevronIcon className={Styles.separator} />}
        </li>
      ))}
    </ul>
  )
}
